/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Renders_DownloadInputs */

const en_directory_ai_tools_renders_download = /** @type {(inputs: Directory_Ai_Tools_Renders_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download MP4`)
};

const zh_directory_ai_tools_renders_download = /** @type {(inputs: Directory_Ai_Tools_Renders_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 MP4`)
};

/**
* | output |
* | --- |
* | "Download MP4" |
*
* @param {Directory_Ai_Tools_Renders_DownloadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_renders_download = /** @type {((inputs?: Directory_Ai_Tools_Renders_DownloadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Renders_DownloadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_renders_download(inputs)
	return zh_directory_ai_tools_renders_download(inputs)
});
export { directory_ai_tools_renders_download as "directory.ai_tools.renders.download" }